module.exports = __webpack_public_path__ + "img/ressource-04.dae878e2.svg";